import React from 'react';
import { LinkedinIcon, ShieldIcon, LockIcon, DownloadIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-950 py-8 border-t border-gray-800" data-id="element-260">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-261">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-262">
          <div className="mb-6 md:mb-0" data-id="element-263">
            <div className="font-bold text-xl flex items-center gap-2" data-id="element-264">
              <ShieldIcon className="w-5 h-5 text-orange-500" data-id="element-265" />
              Emre Tarik Aksoy
            </div>
            <div className="text-gray-400 flex items-center gap-2 mt-1" data-id="element-266">
              <LockIcon className="w-4 h-4 text-green-500" data-id="element-267" />
              <span data-id="element-268">Professioneel Beveiliger | Amsterdam</span>
            </div>
          </div>
          <div className="flex items-center gap-4 mb-6 md:mb-0" data-id="element-269">
            <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition-colors flex items-center gap-1" aria-label="LinkedIn" data-id="element-270">
              <LinkedinIcon className="w-6 h-6" data-id="element-271" />
              <span className="hidden sm:inline" data-id="element-272">LinkedIn</span>
            </a>
            <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors flex items-center gap-1" data-id="element-273">
              <DownloadIcon className="w-6 h-6" data-id="element-274" />
              <span className="hidden sm:inline" data-id="element-275">CV Downloaden</span>
            </a>
          </div>
        </div>
        <div className="mt-6 md:mt-8 pt-6 border-t border-gray-800 text-sm text-gray-500 text-center" data-id="element-276">
          <p data-id="element-277">KVK: 73994979 | Zelfstandig Beveiliger sinds 2022</p>
          <p className="mt-2" data-id="element-278">
            &copy; {new Date().getFullYear()} ETAksoy.nl. Alle rechten
            voorbehouden.
          </p>
        </div>
      </div>
    </footer>;
}